import { createFileRoute, redirect } from '@tanstack/react-router'
import { UserConfigPage } from '@/pages/ClientConfig/UserConfigPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/client-config_/$userId')({
  component: UserConfigPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/client-config')) {
      throw redirect({ to: '/' })
    }
  },
  validateSearch: (search: Record<string, unknown>): { fromRequest?: string } => ({
    fromRequest: typeof search.fromRequest === 'string' ? search.fromRequest : undefined,
  }),
})
